import React from 'react';
import classNames from 'classnames';

import Spinner from './Spinner';

import './loader.scss';

const Loader = ({ isAbsolute }) => {
  const classes = classNames('loader-container', { absolute: isAbsolute });
  return (
    <div className={classes}>
      <Spinner />
    </div>
  );
};

export default Loader;
